const $inject = [];

const flightFilterHelperService = function flightFilterHelperService() {
  const service = {
    setPriceOptionForResult,
    setPriceOptionForResultTime,
    setSliderWithUpdatedOptions,
    setSliderWithUpdatedOptionsTime,
    updatePreviousOptions,
    getTimeCounts,
    memoize
  };

  function setPriceOptionForResult(amountsForResult, previousOptions) {
    const hasVisibleFares = amountsForResult.length > 0;
    const { min, max, defaultMin, defaultMax } = previousOptions;
    const isActive = min > defaultMin || max < defaultMax;
    let updatedOptions = { min: 0, max: 0, defaultMin: 0, defaultMax: 0 };

    if (!hasVisibleFares) return updatedOptions;

    updatedOptions.defaultMin = Math.round(Math.min(...amountsForResult));
    updatedOptions.defaultMax = Math.round(Math.max(...amountsForResult));
    updatedOptions.min = updatedOptions.defaultMin;
    updatedOptions.max = updatedOptions.defaultMax;

    const defaultMinAndMaxChanged = updatedOptions.defaultMin !== defaultMin && updatedOptions.defaultMax !== defaultMax;
    const hasUniquePrice = updatedOptions.defaultMin === defaultMax;

    if (hasUniquePrice) return updatedOptions;

    if (isActive && !defaultMinAndMaxChanged) {
      updatedOptions = { min, max, defaultMin, defaultMax };
      return updatedOptions;
    }
    if (isActive && defaultMinAndMaxChanged) {
      updatedOptions.min = min;
      updatedOptions.max = max;
    }
    return updatedOptions;
  }

  function setPriceOptionForResultTime(departureValues, arrivalValues, previousOptions) {
    const hasVisibleFares = departureValues.length > 0 || arrivalValues.length > 0;

    const { defaultMinDepart, defaultMaxDepart, minDepart, maxDepart, defaultMinArrive, defaultMaxArrive, minArrive, maxArrive } =
      previousOptions;
    const isActive =
      minDepart > defaultMinDepart || maxDepart < defaultMaxDepart || minArrive > defaultMinArrive || maxArrive < defaultMaxArrive;
    let updatedOptions = {
      minDepart: 0,
      maxDepart: 0,
      defaultMinDepart: 0,
      defaultMaxDepart: 0,
      minArrive: 0,
      defaultMinArrive: 0,
      maxArrive: 0,
      defaultMaxArrive: 0,
    };

    if (!hasVisibleFares) return updatePreviousOptions(previousOptions, updatedOptions);

    updatedOptions.defaultMinDepart = roundToLowerMultipleOfFive(Math.round(Math.min(...departureValues)));
    updatedOptions.defaultMaxDepart = roundToHigherMultipleOfFive(Math.round(Math.max(...departureValues)));
    updatedOptions.minDepart = updatedOptions.defaultMinDepart;
    updatedOptions.maxDepart = updatedOptions.defaultMaxDepart;
    updatedOptions.defaultMinArrive = roundToLowerMultipleOfFive(Math.round(Math.min(...arrivalValues)));
    updatedOptions.defaultMaxArrive = roundToHigherMultipleOfFive(Math.round(Math.max(...arrivalValues)));
    updatedOptions.minArrive = updatedOptions.defaultMinArrive;
    updatedOptions.maxArrive = updatedOptions.defaultMaxArrive;

    const defaultMinAndMaxChanged =
      updatedOptions.defaultMinDepart !== defaultMinDepart &&
      updatedOptions.defaultMaxDepart !== defaultMaxDepart &&
      updatedOptions.defaultMinArrive !== defaultMinArrive &&
      updatedOptions.defaultMaxArrive !== defaultMaxArrive;
    const hasUniquePrice = updatedOptions.defaultMinDepart === defaultMaxDepart && updatedOptions.defaultMaxArrive === defaultMaxArrive;

    if (hasUniquePrice) return updatePreviousOptions(previousOptions, updatedOptions);

    if (isActive && !defaultMinAndMaxChanged) {
      updatedOptions = {
        defaultMinDepart: roundToLowerMultipleOfFive(defaultMinDepart),
        defaultMaxDepart: roundToHigherMultipleOfFive(defaultMaxDepart),
        minDepart: roundToLowerMultipleOfFive(minDepart),
        maxDepart: roundToHigherMultipleOfFive(maxDepart),
        minArrive: roundToLowerMultipleOfFive(minArrive),
        defaultMinArrive: roundToLowerMultipleOfFive(defaultMinArrive),
        maxArrive: roundToHigherMultipleOfFive(maxArrive),
        defaultMaxArrive: roundToHigherMultipleOfFive(defaultMaxArrive),
      };
      return updatePreviousOptions(previousOptions, updatedOptions);
    }
    if (isActive && defaultMinAndMaxChanged) {
      updatedOptions.minDepart = minDepart;
      updatedOptions.maxDepart = maxDepart;

      updatedOptions.minArrive = minArrive;
      updatedOptions.maxArrive = maxArrive;
    }
    return updatePreviousOptions(previousOptions, updatedOptions);
  }

  function setSliderWithUpdatedOptions(filter) {
    filter.options.forEach((opt, i) => {
      filter.rzslider[i] = {
        id: filter.id,
        floor: opt.defaultMin,
        ceil: opt.defaultMax,
        noSwitching: true,
        interval: 1000,
        translate: filter.rzsliderCallbacks.translate,
        onChange: filter.rzsliderCallbacks.onChange,
      };
    });
  }

  function setSliderWithUpdatedOptionsTime(filter) {
    filter.options.forEach((opt, i) => {
      filter.rzslider[i] = {};

      var departOptions = {
        defaultMin: roundToLowerMultipleOfFive(opt.defaultMinDepart),
        defaultMax: roundToHigherMultipleOfFive(opt.defaultMaxDepart),
      };
      filter.rzslider[i].depart = generateSliderOptions(filter, departOptions, 5);
      var arrivalOptions = {
        defaultMin: opt.defaultMinArrive,
        defaultMax: opt.defaultMaxArrive,
      };
      filter.rzslider[i].arrival = generateSliderOptions(filter, arrivalOptions, 5);
    });
  }

  function generateSliderOptions(filter, opt, step) {
    return {
      id: filter.id,
      floor: opt.defaultMin,
      ceil: opt.defaultMax,
      noSwitching: true,
      interval: 1000,
      step: step ? step : undefined,
      translate: filter.rzsliderCallbacks.translate,
      onChange: filter.rzsliderCallbacks.onChange,
    };
  }

  function roundToHigherMultipleOfFive(number) {
    return Math.ceil(number / 5) * 5;
  }

  function roundToLowerMultipleOfFive(number) {
    return Math.floor(number / 5) * 5;
  }

  // We should keep the same instance of options to avoid reference problems
  function updatePreviousOptions(previousOptions, updatedOptions) {
    Object.keys(previousOptions).forEach((key) => {
      previousOptions[key] = updatedOptions[key];
    });

    return previousOptions;
  }

  function getTimeCounts(timesArr) {
    var allCount = timesArr.length || 0;

    var morningCount = timesArr.filter((t) => t >= 0 && t <= 720).length || 0;
    var afternoonCount = timesArr.filter((t) => t >= 720 && t <= 1140).length || 0;
    var eveningCount = timesArr.filter((t) => t >= 1140 && t <= 1440).length || 0;

    return [allCount, morningCount, afternoonCount, eveningCount];
  }

  function memoize(func) {
    const cache = new WeakMap(); // Cache based on object references
  
    return function (...args) {
      let currentCache = cache;
  
      for (let i = 0; i < args.length; i++) {
        const arg = args[i];
        if (!currentCache.has(arg)) {
          if (i === args.length - 1) {
            const result = func.apply(this, args); // Final result
            currentCache.set(arg, result);
            return result;
          }
          currentCache.set(arg, new WeakMap()); // Create new cache layer for nested arguments
        }
        currentCache = currentCache.get(arg);
      }
  
      return currentCache;
    };
  }

  return service;
};

flightFilterHelperService.$inject = $inject;

export default flightFilterHelperService;


// WEBPACK FOOTER //
// ./src/services/flightFilterHelperService.js